<div class="invoice-scan-dialog">
  <h2 mat-dialog-title>Review Vendor Invoice (Proposed)</h2>

  <mat-dialog-content class="scan-content">
    <div class="scan-stage">
      <div class="scan-loading" *ngIf="showSpinner">
        <mat-spinner diameter="42"></mat-spinner>
        <p>Reading invoice…</p>
      </div>

      <div class="scan-body" *ngIf="form" [class.pending]="showSpinner" [formGroup]="form">
        <div class="scan-banner" *ngIf="data.proposal?.requiresConfirmation">
          Extraction is proposed only. Compare the invoice to the physical shipment,
          then enter initials and confirm receiving. Nothing is received until you confirm.
        </div>

        <div class="scan-banner warn" *ngIf="data.proposal?.duplicateInvoice">
          Duplicate warning: this vendor invoice number already exists. Confirm only with authorization.
        </div>

        <div class="scan-banner warn" *ngIf="data.proposal?.header?.templateId === 'generic' || data.proposal?.layoutWarning">
          {{ data.proposal.layoutWarning || 'General invoice reader used — verify every proposed field against the original.' }}
        </div>

        <div class="scan-layout">
          <div class="scan-original">
            <h3>Original invoice</h3>
            <div class="invoice-pages" *ngIf="previewPages.length">
              <img
                *ngFor="let page of previewPages; let i = index"
                [src]="page"
                [attr.alt]="'Invoice page ' + (i + 1)"
                (load)="onPreviewLoad()"
                (error)="onPreviewLoad()"
              />
            </div>
            <img
              class="invoice-photo"
              *ngIf="!previewPages.length && isImage && safeDownloadUrl"
              [src]="safeDownloadUrl"
              alt="Vendor invoice"
            />
            <iframe
              *ngIf="!previewPages.length && !isImage && safeObjectUrl"
              [src]="safeObjectUrl"
              title="Vendor invoice"
            ></iframe>
            <p *ngIf="!safeObjectUrl && !previewPages.length" class="muted">
              Original file:
              {{ data.proposal?.invoiceAttachment?.originalName || data.proposal?.extract?.originalName || 'uploaded' }}
            </p>
            <p class="muted" *ngIf="safeDownloadUrl">
              <a [href]="safeDownloadUrl" target="_blank" rel="noopener">Open original invoice</a>
            </p>
            <p class="muted">
              Read with {{ data.proposal?.header?.templateLabel || 'General reader' }}
              · {{ data.proposal?.extract?.method || 'unknown' }}
              · Confidence {{ data.proposal?.header?.confidence || 'low' }}
            </p>
          </div>

          <div class="scan-fields">
            <h3>Proposed header</h3>
            <div class="header-grid">
              <mat-form-field>
                <mat-label>Vendor invoice #</mat-label>
                <input matInput formControlName="invoiceNumber" [class.low-conf]="unreadable.includes('invoiceNumber')">
              </mat-form-field>
              <mat-form-field>
                <mat-label>Invoice date</mat-label>
                <input matInput formControlName="date" [class.low-conf]="unreadable.includes('invoiceDate')">
              </mat-form-field>
              <mat-form-field>
                <mat-label>Shipping</mat-label>
                <input matInput type="number" formControlName="shipping">
              </mat-form-field>
              <mat-form-field>
                <mat-label>Tax / tariff</mat-label>
                <input matInput type="number" formControlName="tax">
              </mat-form-field>
              <mat-form-field>
                <mat-label>Total</mat-label>
                <input matInput type="number" formControlName="total">
              </mat-form-field>
              <mat-form-field>
                <mat-label>Initials</mat-label>
                <input matInput formControlName="initials" maxlength="4">
              </mat-form-field>
            </div>

            <h3>Exceptions</h3>
            <ul class="exceptions" *ngIf="exceptions.length; else noExceptions">
              <li *ngFor="let ex of exceptions">{{ ex.message }}</li>
            </ul>
            <ng-template #noExceptions>
              <p class="muted">No exceptions flagged.</p>
            </ng-template>

            <h3>Line matches</h3>
            <p class="muted">
              Uncheck lines that are not in the box. Missing ordered frames stay in Awaiting Frames.
            </p>
            <table class="line-table">
              <thead>
                <tr>
                  <th>Recv</th>
                  <th>Model</th>
                  <th>Color</th>
                  <th>Size</th>
                  <th>Qty</th>
                  <th>Price</th>
                  <th>Matched order</th>
                  <th>Flags</th>
                </tr>
              </thead>
              <tbody formArrayName="lines">
                <tr
                  *ngFor="let line of lines.controls; let i = index"
                  [formGroupName]="i"
                  [class.low-conf]="lowConfidence(line)"
                  [class.freight]="line.value.isFreight || line.value.isAccessory"
                >
                  <td><mat-checkbox formControlName="receive"></mat-checkbox></td>
                  <td>{{ line.value.model }}</td>
                  <td>{{ line.value.color }}</td>
                  <td>{{ line.value.size }}</td>
                  <td>{{ line.value.quantity }}</td>
                  <td>{{ line.value.unitPrice | currency }}</td>
                  <td>
                    <span *ngIf="line.value.orderId">{{ line.value.orderId | slice:0:8 }}…</span>
                    <span *ngIf="!line.value.orderId">—</span>
                  </td>
                  <td>{{ (line.value.flags || []).join(', ') }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button
      mat-raised-button
      color="primary"
      type="button"
      (click)="confirm()"
      [disabled]="showSpinner || !form || form.invalid || !form.value.initials"
    >
      Confirm Receiving
    </button>
  </mat-dialog-actions>
</div>
